<template>
  <a class="pointer"
     @click="emit('toggleMode')">
    <FullScreenOnSvg v-if="!fullScreenOn" class="svg-gray2 svg-size-xxl"/>
    <FullScreenOffSvg v-if="fullScreenOn" class="svg-gray2 svg-size-xxl"/>
  </a>
</template>

<script setup>
import FullScreenOnSvg from '@/assets/svg-vue/general/full_screen_on.svg'
import FullScreenOffSvg from '@/assets/svg-vue/general/full_screen_off.svg'

const emit = defineEmits(['toggleMode'])

defineProps({
  fullScreenOn: {
    type: Boolean,
    default: false
  },
  size: {

  }
})
</script>
